import { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../assets/css/common/tips.css';
import { isIOS } from '../../utils/helpers/common';

const Tips = ({ text }) => {
    const triggerMode = useMemo(() => (isIOS() ? ['click'] : ['hover', 'focus']), []);

    return (
        <OverlayTrigger
            placement="top"
            trigger={triggerMode}
            overlay={<Tooltip className="custom-tooltip">{text}</Tooltip>}
            rootClose={true}
        >
            <span className="help-icon">?</span>
        </OverlayTrigger>
    );
};

export default Tips;
